module.exports = __webpack_public_path__ + "img/CLB-min.138c965b.png";